var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('com-get-detail',{ref:"mychild",attrs:{"config":_vm.pageConfig},on:{"Action":_vm.startWechatPay}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }